import { render, staticRenderFns } from "./AddEditRegistrationTypePopup.vue?vue&type=template&id=ec48fab2"
import script from "./AddEditRegistrationTypePopup.vue?vue&type=script&lang=js"
export * from "./AddEditRegistrationTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports